    (function () {
  if (window.__pplProductDetailsReady) return;
  window.__pplProductDetailsReady = true;

  function init(root) {
    if (!root || root.dataset.pdsInitialized === 'true') return;
    root.dataset.pdsInitialized = 'true';

      var cfgEl = root.querySelector('[data-pds-config]');
      var isDebug = root.getAttribute('data-pds-debug') === '1';
      var cfg = {};
      try { cfg = JSON.parse(cfgEl.textContent || '{}'); } catch(e) { cfg = {}; }

      function normalizeToken(t){
        return String(t || '')
          .trim()
          .replace(/^"+|"+$/g, '')
          .replace(/^\[+|\]+$/g, '')
          .replace(/,+$/g, '')
          .replace(/\s+/g, '_');
      }

      function parseCareTokens(input){
        if (Array.isArray(input)) return input.map(normalizeToken).filter(Boolean);

        var s = String(input || '').trim();
        if (!s) return [];

        try {
          if (s[0] === '[') {
            var arr = JSON.parse(s);
            if (Array.isArray(arr)) return arr.map(normalizeToken).filter(Boolean);
          }
        } catch(e) {}

        s = s.replace(/^\[|\]$/g, '').replace(/"/g,'');
        if (!s.trim()) return [];
        var parts = s.indexOf('•') !== -1 ? s.split('•') : s.split(',');
        return parts.map(normalizeToken).filter(Boolean);
      }

      function hideField(field){
        var th = root.querySelector('th[data-pds-field="'+field+'"]');
        var td = root.querySelector('td[data-pds-field="'+field+'"]');
        if (th) th.style.display = 'none';
        if (td) td.style.display = 'none';
      }

      function showField(field){
        var th = root.querySelector('th[data-pds-field="'+field+'"]');
        var td = root.querySelector('td[data-pds-field="'+field+'"]');
        if (th) th.style.display = '';
        if (td) td.style.display = '';
      }

      function renderCare(){
        var careWrap = root.querySelector('[data-pds-care]');
        if (!careWrap) return;

        var tokens = parseCareTokens(cfg.care);

        var excluded = new Set(['pf_trock_1','pf_liegtrock_2']);
        tokens = tokens.filter(function(t){ return t && !excluded.has(t); });

        careWrap.innerHTML = '';

        if (!tokens.length) {
          if (!isDebug) {
            hideField('care');
            var row = root.querySelector('tr[data-pds-row="cert-care"]');
            if (row && !cfg.hasOeko) row.style.display = 'none';
          }
          return;
        }

        var map = cfg.careMap || {};
        tokens.forEach(function(tok){
          var src = map[tok];

          if (src) {
            var labels = cfg.careLabels || {};
            var label = labels[tok] || '';
            var wrapper = document.createElement('span');
            wrapper.className = 'pds__careIcon';
            if (label) wrapper.setAttribute('data-tooltip', label);
            var img = document.createElement('img');
            img.className = 'pds__careImg';
            img.loading = 'lazy';
            img.alt = label || tok;
            img.src = src;
            img.setAttribute('data-token', tok);
            if (label) img.title = label;
            wrapper.appendChild(img);
            careWrap.appendChild(wrapper);
          } else if (isDebug) {
            var chip = document.createElement('span');
            chip.className = 'pds__careMiss';
            chip.textContent = tok;
            careWrap.appendChild(chip);
          }
        });

        if (!isDebug && !careWrap.children.length) {
          hideField('care');
          var row2 = root.querySelector('tr[data-pds-row="cert-care"]');
          if (row2 && !cfg.hasOeko) row2.style.display = 'none';
        }
      }

      renderCare();

      var colorCfgEl = root.querySelector('[data-pds-variant-colors]');
      var articleOut = root.querySelector('td[data-pds-field="article"]');
      var colorOut = root.querySelector('[data-pds-color-number]');
      var colorCfg = {};
      try { colorCfg = JSON.parse(colorCfgEl.textContent || '{}'); } catch(e) { colorCfg = {}; }

      function getVariantId(){
        var pi = document.querySelector('product-info');
        if (pi) {
          var sid = pi.getAttribute('data-section') || (pi.dataset ? pi.dataset.section : '') || '';
          if (sid) {
            var f = document.getElementById('product-form-' + sid);
            if (f) {
              var inp = f.querySelector('input[name="id"]');
              if (inp && inp.value) return inp.value;
            }
          }
        }
        var inp2 = document.querySelector('form[action^="/cart/add"] input[name="id"], form[action^="/cart"] input[name="id"]');
        if (inp2 && inp2.value) return inp2.value;
        var any = document.querySelector('input[name="id"]');
        return any && any.value ? any.value : '';
      }

      function applyVariantDetails(){
        var vid = String(getVariantId() || '');
        var articleMap = (colorCfg && colorCfg.variant_articles) ? colorCfg.variant_articles : {};
        var colorMap = (colorCfg && colorCfg.variants) ? colorCfg.variants : {};
        var articleVal = (vid && articleMap && articleMap[vid] != null) ? articleMap[vid] : (colorCfg.product_article || '');
        var val = (vid && colorMap && colorMap[vid] != null) ? colorMap[vid] : (colorCfg.product_color || '');
        articleVal = (articleVal == null) ? '' : String(articleVal).trim();
        val = (val == null) ? '' : String(val).trim();

        if (articleOut && articleVal) {
          articleOut.textContent = articleVal;
        }

        if (colorOut) {
          colorOut.textContent = val;
        }

        // hide/show Farbnummer dynamically (only if column exists)
        if (val) {
          showField('color');
        } else {
          hideField('color');
        }

        // If article cell exists in 4-col layout, expand it when color is hidden
        var artTd = root.querySelector('td[data-pds-field="article"]');
        var colorTh = root.querySelector('th[data-pds-field="color"]');
        if (artTd && colorTh) {
          artTd.colSpan = val ? 1 : 3;
        }
      }

      applyVariantDetails();

      document.addEventListener('variant:change', applyVariantDetails);
      document.addEventListener('variant:changed', applyVariantDetails);
      document.addEventListener('change', function(e){
        var t = e && e.target;
        if (t && t.matches && t.matches('input[name="id"]')) applyVariantDetails();
      });
  }

  function initAll(scope) {
    var context = scope || document;
    if (context.matches && context.matches('[data-pds-root]')) init(context);
    context.querySelectorAll('[data-pds-root]').forEach(init);
  }

  initAll(document);
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
